import types from './actionTypes';

const initialState = {
  loading: false,
  monetizationOrders: [],
  error: '',
};

const monetizationOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_MONETIZATION_ORDER_STATE:
      return initialState;
    case types.CREATE_MONETIZATION_ORDER.REQUEST:
    case types.UPDATE_MONETIZATION_ORDER.REQUEST:
    case types.SYNC_MONETIZATION_ORDERS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.CREATE_MONETIZATION_ORDER.SUCCESS:
    case types.UPDATE_MONETIZATION_ORDER.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case types.SYNC_MONETIZATION_ORDERS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        monetizationOrders: [...action.monetizationOrders],
      };
    case types.CREATE_MONETIZATION_ORDER.FAILURE:
    case types.UPDATE_MONETIZATION_ORDER.FAILURE:
    case types.SYNC_MONETIZATION_ORDERS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default monetizationOrderReducer;
